import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { UXFacetGroup } from '../../models/ux-facets'
import { FacetToggleEvent } from '../../models/facet-toggle-event'
import { AppliedFacets } from '../../models/applied-facets'

@Component({
  selector: 'app-facetgroup-list',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacetgroupListComponent {
  @Input() groups: UXFacetGroup[]
  @Input() openGroups: string[] = []
  @Input('applied') appliedFacets: AppliedFacets
  @Input() loading: boolean
  @Output() facetToggled = new EventEmitter<FacetToggleEvent>()
  @Output() groupToggled = new EventEmitter<string>()

  appliedInGroup(group: UXFacetGroup): string[] {
    return (this.appliedFacets && this.appliedFacets[group.code]) || []
  }

  isOpen(group: UXFacetGroup): boolean {
    return this.openGroups.indexOf(group.code) !== -1
  }

  toggled(event: FacetToggleEvent) {
    this.facetToggled.emit(event)
  }

  facetgroupToggled(event) {
    this.groupToggled.emit(event)
  }
}
